import { createContext } from "react";

export const CreateTeacherContext = createContext()